import React from 'react';
import styled from 'styled-components';
import HubspotForm from 'react-hubspot-form';

import { p, pt, pb, px, py, mt, mb, mx } from 'styled-components-spacing';
import { map } from 'styled-components-breakpoint';
import { colors, Text, Heading } from 'themes/components';

import HighlightText from 'utils/HighlightText';
import GlobeIcon from './Icons/GlobeIcon';
import Eyebrow from './Eyebrow';
import { HubSpotFormStyles } from 'utils/HubSpotFormStyles';

const Container = styled.div`
  ${py({ mobile: 5, desktop: 8, xl: 10 })};
  ${px(2)};
  display: grid;
  max-width: 1280px;
  margin: 0 auto;
  ${mt({ mobile: 4, tablet: 8 })};
  ${map(
    {
      mobile: '24px',
      tablet: '40px'
    },
    (gap) => `gap: ${gap};`
  )}
  ${map(
    {
      mobile: '"content" "demo"',
      tablet: '"content demo"'
    },
    (area) => `grid-template-areas: ${area};`
  )}
  ${map(
    {
      mobile: '1fr',
      tablet: '1fr 1fr',
      desktop: '0.7fr 1fr'
    },
    (cols) => `grid-template-columns: ${cols};`
  )}
  align-items: center;
`;

const TextContainer = styled.div`
  color: ${colors.grey20};
`;

const Left = styled.div``;
const Right = styled.div`
  border-radius: 16px;
  & > h3 {
    color: ${colors.grey5};
    ${mb(0)}
  }
  & > p {
    color: ${colors.grey30};
  }
`;

const Registration = styled.div`
  background: ${colors.grey70};
  border: 1px solid ${colors.grey60};
  border-radius: 8px;
  ${p(1)};
  a {
    color: ${colors.teal40};
  }
  & > h3 {
    ${mb(2)};
  }
  ${HubSpotFormStyles}
`;

const EndingCta = () => {
  const MyHubspotForm = () => (
    <HubspotForm
      portalId="21257089"
      formId="3312bff8-7ace-49c3-963d-250bfdccc2d5"
    />
  );
  return (
    <Container>
      <Left>
        <Eyebrow
          bg1="rgba(59, 48, 73, 0.75)"
          bg2="rgba(46, 52, 54, 0.75)"
          border1="rgba(168, 99, 255, 0.55)"
          border2="rgba(29, 155, 240, 0.28)"
        >
          <GlobeIcon />
          <HighlightText
            direction="right"
            stopOne={colors.purple30}
            stopTwo={colors.blue30}
          >
            From everywhere. At any time.
          </HighlightText>
        </Eyebrow>
        <Heading
          variant="h2"
          style={{ marginBottom: '16px', color: colors.heading }}
        >
          Even if your team is remote,
          <HighlightText
            direction="right"
            stopOne={colors.purple30}
            stopTwo={colors.blue30}
          >
            your art needs to be accessible.
          </HighlightText>
        </Heading>
        <TextContainer>
          <Text variant="large">
            Off-the-shelf cloud storage solutions don’t work for ambitious game
            studios. Change the status quo with an artist-first tool.
          </Text>
        </TextContainer>
      </Left>
      <Right>
        <Registration>
          <Heading variant="h3">Get a demo</Heading>
          <MyHubspotForm />
        </Registration>
      </Right>
    </Container>
  );
};

export default EndingCta;
